import { useMemo } from "react";

import type { Position } from "~/v2/api/rest/account";

interface UseAvailableQuantityProps {
  position: Position | undefined;
}

export const getAvailableQuantity = ({
  position,
}: UseAvailableQuantityProps) => ({
  sharesAvailable: position?.qty_available
    ? Number(position.qty_available)
    : undefined,
  dollarsAvailable: position?.market_value
    ? Number(position.market_value).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      })
    : undefined,
});

export const useAvailableQuantity = ({
  position,
}: UseAvailableQuantityProps) => {
  const { sharesAvailable, dollarsAvailable } = useMemo(
    () => getAvailableQuantity({ position }),
    [position],
  );

  return { sharesAvailable, dollarsAvailable };
};
